












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { bus, store } from './shared';
import BaseHeader from './layouts/partials/Header.vue';
import BaseFooter from './layouts/partials/Footer.vue';

@Component({
    components: {
      BaseHeader,
      BaseFooter,
    },
})
export default class App extends Vue {
  get store() { return store; }
}

